import { ConfigMessageView as Message } from './Message';
import { ConfigMessageThreadView as MessageThread } from './MessageThread';
import { Compose } from './Compose';

export { MessageThread, Compose }
export default Message;